// extracted by mini-css-extract-plugin
export default {"select":"MenuShortcut_select__L5MW9","wrapper":"MenuShortcut_wrapper__NMt5Q"};